module.exports = __webpack_public_path__ + "img/um.a1454bbb.svg";